import React from 'react';

export interface BankContext {
    history: import('react-router').RouteComponentProps['history'];
    bankingData: {
        [x: string]: string;
    };
    fetchTransaction: (transactionId?: number) => Promise<unknown>;
    refreshFinancialSources: () => Promise<unknown>;
    clearFinancialSources: () => Promise<unknown>;
    toggleLoader: (doToggle?: boolean) => void;
}

export default React.createContext<BankContext>({} as BankContext);
